import { merge } from "react-merge"
import { useMediaQuery } from "react-responsive"
import { Color } from "../../enums/Color"
import ContentLoader from "react-content-loader"

const loaderStyle = {
  mobile : {
    form: {
      height: "90.82vw",
      marginTop: "7.73vw",
      width: "90.33vw",
      marginLeft: "4.83vw"
    }
  },
  desktop: {
    form: {
      height: "45.68vw",
      width: "43.95vw",
      marginTop: "1.56vw"
    }
  }
};

export const VacancyQuestionLoader : React.FC = () => {
  const isMobile = useMediaQuery({ query : "(max-width: 786px)"});
  var style = loaderStyle.mobile;
  
  if(!isMobile) {
    let extendedStyle = merge(loaderStyle.mobile, loaderStyle.desktop);
    style = extendedStyle;
  }
  
  return (
    <div style={style.form}>
      <ContentLoader
        speed={1}
        backgroundColor={Color.LoaderBackground}
        foregroundColor={Color.LoaderForeground}
        width= "auto"
        height= {style.form.height}
      > 
        {isMobile ? <>
          <rect x="0" y="0" rx="3" ry="3" width="100%" height="17.00%" />
          <rect x="0" y="22.29%" rx="3" ry="3" width="100%" height="38.14%"/> 
          <rect x="0" y="63.86%" rx="3" ry="3" width="100%" height="48.14%" />
        </> : 
        <>
          <rect x="0" y="0" rx="3" ry="3" width="100%" height="17.20%" />
          <rect x="0" y="22.00%" rx="3" ry="3" width="100%" height="35.20%" />
          <rect x="0" y="60.89%" rx="3" ry="3" width="100%" height="14.20%" />
          <rect x="0" y="78.89%" rx="3" ry="3" width="100%" height="14.20%" />
        </>} 
      </ContentLoader>
    </div>
  )
}